import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Row } from 'react-bootstrap';
import CampaignsPageHeader from 'components/Campaigns/PageHeader';
import CampaignsKPIWidget from 'components/Campaigns/KPIWidget';
import CampaignsTablesWidget from 'containers/Campaigns/TablesWidget';
import { CAMPAIGNS_TYPE } from 'utils/types';
import { ROUTES } from 'utils/routes';
import * as selectors from 'containers/Campaigns/selectors';
import * as actions from 'containers/Campaigns/actions';
import * as createEditActions from 'containers/Campaigns/CreateEdit/store/actions';
import * as pageHeaderSelectors from 'containers/PageHeader/selectors';
import * as pageHeaderActions from 'containers/PageHeader/actions';
import CreateEditCampaignModal from 'containers/Campaigns/CreateEdit';
import ViewCampaignModal from 'containers/Campaigns/View';
import DataPeriodSelect from 'components/DataPeriodSelect';
import ReactGA from 'react-ga';
import './styles.scss';

interface Props {
  currentTab: string;
  currentWeeks: number;
  history: any;
  selectedCampaign: string;
  onCreateCampaign(): void;
  onCurrentWeeksSet(weeks: number): void;
  onSelectionClear(): void;
  onTabSelect(tab: string): void;
}

const Campaigns: React.FC<Props> = ({
  currentTab,
  currentWeeks,
  history,
  selectedCampaign,
  onCreateCampaign,
  onCurrentWeeksSet,
  onSelectionClear,
  onTabSelect,
}) => {
  useEffect(() => {
    ReactGA.pageview(ROUTES.CAMPAIGNS);
    return () => {
      onSelectionClear();
      onTabSelect(CAMPAIGNS_TYPE);
    };
  }, [onSelectionClear, onTabSelect]);

  const navigateToDetails = (key: string, elem: any) => {
    let nameParam = elem.name;
    history.push({
      pathname: '/campaign-details',
      search: `?campaign=${key}&$campaign_name=${encodeURIComponent(nameParam)}`,
      state: elem,
    });
  };

  return (
    <div className="campaigns">
      <Row>
        <CampaignsPageHeader>
          <div className="header-buttons-container">
            {currentTab === CAMPAIGNS_TYPE && (
              <DataPeriodSelect currentWeeks={currentWeeks} onSelect={onCurrentWeeksSet} />
            )}
            <Button className="btn-create-campaign" onClick={() => onCreateCampaign()}>
              CREATE CAMPAIGN
            </Button>
          </div>
        </CampaignsPageHeader>
      </Row>
      {currentTab === CAMPAIGNS_TYPE && selectedCampaign !== null && (
        <Row className="mt-3">
          <Col>
            <CampaignsKPIWidget />
          </Col>
        </Row>
      )}
      <Row className="mt-3">
        <Col>
          <CampaignsTablesWidget onRowClick={navigateToDetails} />
        </Col>
      </Row>
      <CreateEditCampaignModal />
      <ViewCampaignModal />
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentTab: selectors.currentTabSelector(state),
  currentWeeks: pageHeaderSelectors.globalFilterWeeksSelector(state),
  selectedCampaign: selectors.selectedCampaignSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  onCreateCampaign: () => {
    dispatch(createEditActions.openCreateCampaignModal());
  },
  onCurrentWeeksSet: (weeks: number) => {
    dispatch(pageHeaderActions.updateGlobalFilterWeeks(weeks));
  },
  onSelectionClear: () => {
    dispatch(actions.clearSelection());
  },
  onTabSelect: (value: string) => {
    dispatch(actions.selectTab(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Campaigns);
